<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">EV Charging Jobs</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ติดตามและหยุดงานชาร์จ EV ที่กำลังทำงาน</p>
      <span *ngIf="siteState.selectedSite()?.name"
        class="inline-flex items-center gap-1 mt-3 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
        <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
      </span>
    </div>
    <div class="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center self-start">
      <span *ngIf="runningCount > 0"
        class="inline-flex items-center gap-1.5 self-center px-3 py-1.5 rounded-full bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 text-xs font-bold border border-emerald-100 dark:border-emerald-800">
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
        กำลังชาร์จ {{ runningCount | number }}
      </span>
      <span class="text-xs text-slate-400 whitespace-nowrap self-center">
        ดึงข้อมูลล่าสุด:
        <strong class="text-slate-600 dark:text-slate-300">
          {{ lastFetchedAt ? (lastFetchedAt | date:'HH:mm:ss') : 'ยังไม่ได้ดึงข้อมูล' }}
        </strong>
      </span>
      <button type="button" (click)="onRefresh()" title="ดึงข้อมูล"
        class="px-4 py-3 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons">refresh</span>
        <span class="font-bold">ดึงข้อมูล</span>
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4">
      <div class="flex flex-col lg:flex-row lg:items-end gap-4">
        <div class="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">วันเริ่มต้น</label>
            <div
              class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 transition-all h-[46px]">
              <span class="material-icons text-slate-400 text-xl shrink-0">calendar_today</span>
              <div class="relative flex-1 h-full flex items-center">
                <div
                  class="absolute inset-0 flex items-center justify-between px-1 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                  <span>{{ startDate ? (startDate | date:'dd/MM/yyyy') : 'เลือกวันที่' }}</span>
                  <span class="material-icons text-slate-400 text-lg">expand_more</span>
                </div>
                <input #startDatePicker type="date" [(ngModel)]="startDate" [max]="endDate || null"
                  (change)="onDateChange()" (click)="startDatePicker.showPicker()"
                  class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]" />
              </div>
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">วันสิ้นสุด</label>
            <div
              class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 transition-all h-[46px]">
              <span class="material-icons text-slate-400 text-xl shrink-0">event</span>
              <div class="relative flex-1 h-full flex items-center">
                <div
                  class="absolute inset-0 flex items-center justify-between px-1 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                  <span>{{ endDate ? (endDate | date:'dd/MM/yyyy') : 'เลือกวันที่' }}</span>
                  <span class="material-icons text-slate-400 text-lg">expand_more</span>
                </div>
                <input #endDatePicker type="date" [(ngModel)]="endDate" [min]="startDate || null"
                  (change)="onDateChange()" (click)="endDatePicker.showPicker()"
                  class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-1 p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl h-auto min-h-[46px] shadow-sm">
        <button type="button" (click)="setJobStatusFilter('all')"
          class="px-3 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer whitespace-nowrap"
          [ngClass]="jobStatusFilter === 'all' ? 'bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-100 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600'">
          ทั้งหมด
        </button>
        <div class="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-0.5"></div>
        <button type="button" (click)="setJobStatusFilter('running')"
          class="px-3 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer whitespace-nowrap flex items-center gap-1.5"
          [ngClass]="jobStatusFilter === 'running' ? 'bg-white dark:bg-slate-700 text-emerald-600 dark:text-emerald-400 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-emerald-600 dark:hover:text-emerald-400'">
          <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" *ngIf="jobStatusFilter === 'running'"></span>
          กำลังชาร์จ
          <span *ngIf="runningCount > 0"
            class="ml-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full"
            [ngClass]="jobStatusFilter === 'running' ? 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300' : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
            {{ runningCount }}
          </span>
        </button>
        <div class="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-0.5"></div>
        <button type="button" (click)="setJobStatusFilter('completed')"
          class="px-3 py-2 rounded-lg text-sm font-bold transition-all cursor-pointer whitespace-nowrap"
          [ngClass]="jobStatusFilter === 'completed' ? 'bg-white dark:bg-slate-700 text-slate-600 dark:text-slate-200 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600'">
          จบแล้ว
        </button>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading || isStopping"></app-pss-loading>
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading || isStopping">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">Job ID</th>
            <th class="p-4">ทะเบียน</th>
            <th class="p-4">ช่องจอด</th>
            <th class="p-4 text-center">สถานะ</th>
            <th class="p-4">เริ่ม–จบ</th>
            <th class="p-4 text-right">นาที</th>
            <th class="p-4 text-right">kWh</th>
            <th class="p-4">ลาน</th>
            <th class="p-4 text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngIf="!selectedSiteId && !isLoading">
            <td colspan="9" class="py-16 text-center text-slate-400 font-bold">กรุณาเลือกลานจาก Sidebar</td>
          </tr>
          <tr *ngFor="let job of jobs; trackBy: trackById" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40">
            <td class="p-4">
              <div class="flex flex-col gap-0.5 min-w-0">
                <span class="font-mono text-sm font-bold text-slate-700 dark:text-slate-200 truncate max-w-[12rem]"
                  [title]="job.jobId">{{ job.jobId || '—' }}</span>
                <span class="text-[11px] font-mono text-slate-400">#{{ job.id }}</span>
              </div>
            </td>
            <td class="p-4 font-mono text-sm text-slate-700 dark:text-slate-200">{{ job.licensePlate || '—' }}</td>
            <td class="p-4">
              <span class="px-2.5 py-1 rounded-lg bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
                {{ job.spaceCode || '—' }}
              </span>
            </td>
            <td class="p-4 text-center">
              <span
                class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm"
                [ngClass]="{
                  'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800': job.jobStatus?.toLowerCase() === 'running' || job.isRunning,
                  'bg-slate-50 dark:bg-slate-900/40 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-600': job.jobStatus?.toLowerCase() === 'completed' && !job.isRunning
                }">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5"
                  [ngClass]="(job.jobStatus?.toLowerCase() === 'running' || job.isRunning) ? 'bg-emerald-500 animate-pulse' : 'bg-slate-400'"></span>
                {{ statusLabel(job.jobStatus) }}
              </span>
            </td>
            <td class="p-4 text-xs whitespace-nowrap">
              <div class="flex flex-col gap-0.5">
                <span>{{ formatDateTime(job.chargingStart) }}</span>
                <span class="text-slate-400">{{ formatDateTime(job.chargingEnd) }}</span>
              </div>
            </td>
            <td class="p-4 text-right font-mono text-sm">
              {{ job.durationMinutes != null ? (job.durationMinutes | number) : '—' }}
            </td>
            <td class="p-4 text-right font-mono text-sm">
              {{ job.chargingKwh != null ? (job.chargingKwh | number:'1.0-3') : '—' }}
            </td>
            <td class="p-4 text-xs">{{ job.siteName || job.siteEv || '—' }}</td>
            <td class="p-4 text-center">
              <div class="inline-flex items-center justify-center gap-1.5 flex-wrap">
                <button type="button" (click)="openActivityHistory(job.id)"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-slate-500 dark:text-slate-400 bg-slate-50 dark:bg-slate-800 hover:bg-amber-500 dark:hover:bg-amber-600 hover:text-white transition-all shadow-sm cursor-pointer"
                  title="ดูประวัติ">
                  <span class="material-icons text-[18px]">history</span>
                </button>
                <button *ngIf="canStop(job)" type="button" (click)="openStopConfirm(job)" [disabled]="isStopping"
                  class="inline-flex items-center gap-1 px-3 py-1.5 rounded-xl bg-rose-50 dark:bg-rose-900/20 text-rose-600 dark:text-rose-400 text-xs font-bold border border-rose-100 dark:border-rose-800 hover:bg-rose-100 dark:hover:bg-rose-900/40 disabled:opacity-50 transition-all cursor-pointer">
                  <span class="material-icons text-[16px]">stop_circle</span>
                  หยุด job
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading && jobs.length === 0">
            <td colspan="9" class="py-16 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">ev_station</span>
              <p class="font-bold">ไม่พบ charging job</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold cursor-pointer"
          [ngClass]="page === currentPage ? 'bg-amber-400 text-white' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ page }}
        </button>
        <button type="button" (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages || totalPages === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="isConfirmStopOpen"
  title="ยืนยันหยุด charging job?"
  message="จะตั้งสถานะเป็น completed และหยุด job"
  [highlight]="stopConfirmHighlight"
  messageSuffix="ดำเนินการต่อหรือไม่?"
  confirmLabel="หยุด job"
  cancelLabel="ยกเลิก"
  icon="stop_circle"
  variant="danger"
  [showIrreversibleNote]="true"
  (confirm)="confirmStop()"
  (cancel)="closeStopConfirm()">
</app-pss-confirm-modal>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && activityHistoryJobId"
  [entityType]="activityEntityTypes.EvChargingJob"
  [entityId]="activityHistoryJobId"
  title="ประวัติ EV Charging Job"
  [subtitle]="'#' + activityHistoryJobId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
